import { create } from 'zustand';
import {
  BaseTeamRole,
  BaseWorkspaceRole,
  TeamRole,
  WorkspaceRoleWithPermissions,
} from 'callabo-api/src';

type RoleStore = {
  baseWorkspaceRoles: BaseWorkspaceRole[];
  workspaceRoles: WorkspaceRoleWithPermissions[];
  baseTeamRoles: BaseTeamRole[];
  teamRoles: TeamRole[];
};

export const useRoleStore = create<RoleStore>(() => ({
  baseWorkspaceRoles: [
    BaseWorkspaceRole.WORKSPACE_MANAGER,
    BaseWorkspaceRole.ARCHIVIST,
    BaseWorkspaceRole.VIEWER,
  ],
  workspaceRoles: [],
  baseTeamRoles: [BaseTeamRole.MANAGER, BaseTeamRole.EDITOR, BaseTeamRole.VIEWER],
  teamRoles: [],
}));

export const setRoleStore = (partial: Partial<RoleStore>) => {
  useRoleStore.setState({
    ...partial,
  });
};
